<script setup lang="ts">
interface Props {
  id?: string
  iconUrl?: string | null
  bgClass?: string
}

withDefaults(defineProps<Props>(), {
  iconUrl: null,
  bgClass: 'bg-primary',
})
</script>

<template>
  <div
    v-show="iconUrl"
    class="bg-cover"
    :class="bgClass"
    :style="{
      '-webkit-mask': `url(${iconUrl}) center/contain no-repeat`,
      mask: `url(${iconUrl}) center/contain no-repeat`,
    }"
  >
    <ImageComponent
      :id
      :src="iconUrl"
      class="hidden"
    />
  </div>
</template>
